module.exports = __webpack_public_path__ + "img/screen.c0679535.png";